import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { AssetPathResolverService } from '@blk/cwp-ng-framework';
import { first } from 'rxjs/operators';

@Component({
	// eslint-disable-next-line @angular-eslint/component-selector
	selector: 'bfa-build-info',
	templateUrl: './build-info.component.html',
	styleUrls: ['./build-info.component.scss']
})
export class BuildInfoComponent implements OnInit {
	public environment: any;

	constructor(
		private assetPathResolver: AssetPathResolverService,
		private http: HttpClient
	) { }

	public ngOnInit(): void {
		const path = this.assetPathResolver.getPath('/assets/environment/environment.json');
		this.http.get(path).pipe(first()).subscribe(environment => {
			console.log('Environment', environment);
			this.environment = environment;
		});
	}

}
